<template>
  <v-list>
    <v-list-tile
      v-for="option in extra.options"
      :key="option.key">
      <v-checkbox
        v-model="selected"
        :multiple="multiple"
        :value="option.key"
        :label="$t(option.value)"
        :disabled="isDisabled(option)"
        hide-details
      />
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'OrderDraftItemExtraSelection',

  props: {
    extra: {
      type: Object,
      required: true
    },
    value: {
      validator: (val) => Array.isArray(val) || val === undefined,
      default: () => []
    }
  },

  computed: {
    multiple () {
      return this.extra.limit === undefined || this.extra.limit === null || this.extra.limit > 1
    },

    selected: {
      get () {
        return this.multiple ? [...this.value] : this.value[0]
      },
      set (value) {
        this.$emit('input', this.multiple ? value : value === null ? [] : [value])
        this.$emit('change')
      }
    }
  },

  methods: {
    isDisabled (item) {
      if (this.value.includes(item)) {
        return false
      }

      return !!(this.extra.limit && this.extra.limit <= this.value.length)
    }
  }
}
</script>
